import {
  Configuration,
  IPublicClientApplication,
  PublicClientApplication,
} from "@azure/msal-browser";
import axios from "axios";

import { env } from "./env";

const config = env.graphApiConfig;

const scopes = ["https://graph.microsoft.com/.default"];

const msalConfig: Configuration = {
  auth: {
    clientId: config.clientId,
    authority: `https://login.microsoftonline.com/${config.tenantId}`,
    redirectUri: config.redirectUri,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

let msalInstance: IPublicClientApplication;
let token: string | null = null;
export default class Teams {
  public static async login() {
    try {
      if (!msalInstance) {
        msalInstance =
          await PublicClientApplication.createPublicClientApplication(
            msalConfig
          );
      }

      const loginResponse = await msalInstance.loginPopup({
        scopes,
        redirectUri: config.redirectUri,
      });

      token = loginResponse.accessToken;
    } catch (err) {
      console.error("login failed", err);
      throw new Error("Login failed.");
    }
  }

  public static async getAccessToken() {
    try {
      if (!msalInstance) {
        msalInstance =
          await PublicClientApplication.createPublicClientApplication(
            msalConfig
          );
      }

      const accounts = msalInstance.getAllAccounts();

      if (accounts.length === 0 || accounts.length > 1) {
        await this.login();
        return;
      }

      const result = await msalInstance.acquireTokenSilent({
        scopes,
        redirectUri: config.redirectUri,
        account: accounts[0],
      });

      token = result.accessToken;
    } catch (err) {
      console.warn("getAccessToken failed", err);
      await this.login();
    }
  }

  public static async sendChatMessage(chatId: string, message: string) {
    try {
      await axios.post(
        `https://graph.microsoft.com/v1.0/chats/${chatId}/messages`,
        {
          body: {
            content: message,
            contentType: "html",
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
    } catch (err) {
      console.error(err);
      throw new Error("Failed to send chat message");
    }
  }
}
